import { Typography } from 'antd';
import ChatSessionTickets from 'components/ai-agent-center/ChatSessionTickets';
import Avatar from 'components/common/avatar/Avatar';
import { useOmniHistoriesLeadManageContext } from 'contexts';
import dayjs from 'dayjs';
import { useCountAssignerProcessingChatSessions } from 'hooks';
import { omniChatMessages } from 'messages';

type OngoingChatDetailsProps = {};

const OngoingChatDetails: React.FC<OngoingChatDetailsProps> = ({}) => {
  const { chatOngoing } = useOmniHistoriesLeadManageContext();
  const { data: processingChatSessionsCount } = useCountAssignerProcessingChatSessions(chatOngoing?.assignerId!);

  return (
    <div className='flex h-[calc(100vh-240px)] flex-col overflow-y-auto'>
      <div className='flex h-16 items-center gap-2 border-b px-4'>
        <Typography.Text className='text-lg font-semibold'>{omniChatMessages.chatDetails}</Typography.Text>
      </div>
      <div className='max-h-[calc(100%-56px)] overflow-hidden'>
        <div className='border-b pb-6 pt-5'>
          <div className='px-5'>
            <Typography.Text className='text-lg font-semibold'>{omniChatMessages.supportingDTV}</Typography.Text>
            <div className='flex flex-col items-center pt-8'>
              <Avatar
                key={chatOngoing?.assigner?.userId}
                size={80}
                src={chatOngoing?.assigner?.avatar}
                name={chatOngoing?.assigner?.fullName}
              />
              <Typography.Text className='mt-5 font-semibold'>{chatOngoing?.assigner?.fullName}</Typography.Text>
              <Typography.Text className='mt-1 text-sm' type='secondary'>
                {processingChatSessionsCount} {omniChatMessages.chatSession}
              </Typography.Text>
            </div>
          </div>
        </div>
        <div className='border-b pb-6 pt-5'>
          <div className='flex flex-col px-5'>
            <Typography.Text className='text-lg font-semibold'>{omniChatMessages.processingTime}</Typography.Text>
            <Typography.Text className='mt-4'>
              Từ {dayjs(chatOngoing?.processingAt).format('HH:mm')}
              {chatOngoing?.completedAt ? `đến ${dayjs(chatOngoing?.completedAt).format('HH:mm')}` : ''}
            </Typography.Text>
          </div>
        </div>
        <ChatSessionTickets chatSessionId={chatOngoing?.chatSessionId} titleClassName='text-lg' className='border-b' />
      </div>
    </div>
  );
};

export default OngoingChatDetails;
